/* This file is autogenerated, see readme.md for instructions */
import StopwatchSvgIcon from '@bloomreach/banana-theme/icons/stopwatch.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StopwatchIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StopwatchSvgIcon />
    </Icon>
  );
});

StopwatchIcon.displayName = 'StopwatchIcon';

export default StopwatchIcon;
